// assets
import { IconUsers  } from '@tabler/icons';


// constant
const icons = {
    IconUsers 
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const agentManagement = {
    id: 'masterManagement',
    type: 'group',
    children: [
        {
            id: 'masterManagement',
            title: 'Master Management',
            type: 'collapse',
            icon: icons.IconUsers ,

            children: [
                {
                    id: 'list',
                    title: 'List',
                    type: 'item',
                    url: '/master-management/list',
                    breadcrumbs: true
                },
                {
                    id: 'pointAjustment',
                    title: 'Point Ajustment',
                    type: 'item',
                    url: '/master-management/pointAdjustment',
                    breadcrumbs: true
                },
                {
                    id: 'rule',
                    title: 'Rules',
                    type: 'item',
                    url: '/master-management/rules',
                    breadcrumbs: true
                },
                {
                    id: 'system-noti',
                    title: 'System Noti',
                    type: 'item',
                    url: '/master-management/noti',
                    breadcrumbs: true
                },

            // children: [
            //     {
            //         id: 'list',
            //         title: 'List',
            //         type: 'item',
            //         url: '/master-management/list',
            //         breadcrumbs: true
            //     },
            //     {
            //         id: 'createUser',
            //         title: 'Create User',
            //         type: 'item',
            //         url: '/master-management/createUser',
            //         breadcrumbs: true
            //     },
                // {
                //     id: 'pointAjustment',
                //     title: 'Point Ajustment',
                //     type: 'item',
                //     url: '/master-management/pointAdjustment',
                //     breadcrumbs: true
                // },
                // {
                //     id: 'memberInfo',
                //     title: 'Member Info',
                //     type: 'item',
                //     url: '/master-management/memberInfo',
                //     breadcrumbs: true
                // },
                // {
                //     id: 'subAccounts',
                //     title: 'Sub Accounts',
                //     type: 'item',
                //     url: '/master-management/subAccounts',
                //     breadcrumbs: true
                // },
                // {
                //     id: 'createSubAccount',
                //     title: 'Create Sub Account',
                //     type: 'item',
                //     url: '/master-management/createSubAccount',
                //     breadcrumbs: true
                // }
            ]
        }
    ]
};

export default agentManagement;
